import { useQuery } from 'react-query'

// eslint-disable-next-line import/no-internal-modules
import { SystemPreferencesRepository } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository'
// eslint-disable-next-line import/no-internal-modules
import { systemPreferencesKeys } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository/queryKey.factory'
// eslint-disable-next-line import/no-internal-modules
import { SystemPreferenceKeys } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'

export const useQueryDefaultPODisclaimer = () => {
  const { data, isLoading } = useQuery({
    queryKey: systemPreferencesKeys.defaultDisclaimer,
    queryFn: async (): Promise<number | null> => {
      try {
        const preference =
          await SystemPreferencesRepository.getSystemPreference(
            SystemPreferenceKeys.DEFAULT_DISCLAIMER
          )
        return preference.value
      } catch {
        // 404 / missing key is a valid "no default set" state — never
        // surfaced as an error (BHV-018)
        return null
      }
    },
  })

  return {
    value: data ?? null,
    isLoading,
  }
}
